export enum IntegrationStatus {
  connecting = "connecting",
  connected = "connected",
  broken = "broken",
}

export enum IntegrationStyle {
  custom = "custom",
  oauth = "oauth",
}

export interface Integration {
  id: number;
  "workspace-id": number;
  integration: string;
  status: IntegrationStatus;
  style: IntegrationStyle;
  "access-token": string;
  "refresh-token": string | null;
  data: Record<string, any>;
  "created-at": string;
  "updated-at": string;
}

export interface IntegrationSchema {
  id: string;
  label: string;
  style: IntegrationStyle;
  status: IntegrationStatus;
  context: IntegrationContextField[];
}

export enum IntegrationContextFieldType {
  AccessToken = "access-token",
  FacebookCAPIDataset = "facebook-capi-dataset-id",
  ShopifyShopURL = "shopify-shop-url",
  ShopifyAccessToken = "shopify-access-token",
}

export interface IntegrationContextField {
  id: string;
  label: string;
  type: IntegrationContextFieldType;
}
